import apiClient from "../common";

export type DriveFolder = {
  id: string;
  name: string;
};

export type DriveFoldersResponse = {
  parent: string;
  is_root: boolean;
  folders: DriveFolder[];
};

/**
 * GET /api/v1/integrations/drive/folders/?parent={id}
 * Lista las subcarpetas de `parentId`. Sin `parentId` usa la raíz configurada
 * en el backend (DJANGO_GOOGLE_DRIVE_PURCHASING_FOLDER_ID).
 */
export async function apiListDriveFolders(
  parentId?: string,
): Promise<DriveFoldersResponse> {
  const res = await apiClient.get("integrations/drive/folders/", {
    withCredentials: true,
    params: parentId ? { parent: parentId } : undefined,
  });
  const data = res.data as Partial<DriveFoldersResponse>;
  return {
    parent: String(data.parent ?? parentId ?? ""),
    is_root: Boolean(data.is_root),
    folders: Array.isArray(data.folders)
      ? data.folders.map((f) => ({ id: String(f.id), name: String(f.name) }))
      : [],
  };
}
